export { default } from './masked-input';
